module.exports = __webpack_public_path__ + "static/img/github_image@2x.3a98110.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/2x/github_image@2x.png
// module id = MKuP
// module chunks = 1